const e = {
  base: "bg-white rounded-lg border px-4 !min-h-5xl cursor-pointer gap-2",
  disabled: "bg-slate-200 text-slate-400 cursor-not-allowed",
  invalid: "border-red-600",
  multi: "py-[0.38rem] h-max",
  menuOpened: "rounded-b-none"
}, t = "text-slate-500 text-b2 capitalize truncate", s = {
  base: "h-10 text-b2 !flex",
  selected: "pt-4"
}, o = "p-1 h-fit gap-1", l = {
  base: "h-fit text-b2",
  selected: "pt-4"
}, r = "", n = {
  base: "p-1 text-slate-600 ",
  disabled: "bg-transparent"
}, a = "mt-[-2px] border border-slate-200 bg-white rounded-b-lg !z-20 text-b2 overflow-hidden", d = "bg-slate-50 text-b2 text-slate-600 p-3", b = {
  base: "flex items-center hover:cursor-pointer p-3 gap-2 text-slate-900 hover:bg-slate-50",
  selected: "bg-green-100 text-slate-900 hover:bg-slate-50"
}, c = "p-2 bg-slate-50 border border-dashed border-slate-200 rounded-sm";
export {
  e as controlStyles,
  n as dropdownIndicatorStyles,
  d as groupHeadingStyles,
  r as indicatorsContainerStyles,
  a as menuStyles,
  c as noOptionsMessageStyles,
  b as optionStyles,
  t as placeholderStyles,
  s as selectInputStyles,
  l as singleValueStyles,
  o as valueContainerStyles
};
